<template>
  <div>
    <b-form>
      <b-form-group :label="$store.state.form.judul" label-cols-md="3">
        <b-form-input type="text" :state="checkIfValid('namaLoker')" v-model="$v.data.namaLoker.$model"></b-form-input>
      </b-form-group>

      <b-form-group label-cols-md="3">
        <template v-slot:label>
          {{ $store.state.form.divisi }}
          <span class="text-danger">*</span>
        </template>
        <Multiselect
          v-model="data.masterDivisiId"
          :options="divisi"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          track-by="id"
          @input="getPosisi(data.masterDivisiId)"
          label="namaDivisi"
          :placeholder="$store.state.form.divisiPlaceholder"
        ></Multiselect>
      </b-form-group>

      <b-form-group :label="$store.state.form.posisi" label-cols-md="3">
        <Multiselect
          :state="checkIfValid('posisi')"
          v-model="$v.data.posisi.$model"
          :options="posisi"
          :multiple="false"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          label="namaPosisi"
          track-by="namaPosisi"
          :placeholder="$store.state.form.posisiPlaceholder"
        ></Multiselect>
      </b-form-group>

      <b-form-group :label="$store.state.form.keterangan" label-cols-md="3">
        <quill-editor v-model="data.keteranganLoker"></quill-editor>
      </b-form-group>

      <b-form-group :label="$store.state.form.tanggalAkhirLowongan" label-cols-md="3">
        <date-picker style="width: 100%" :state="checkIfValid('tanggalAkhirLoker')" v-model="$v.data.tanggalAkhirLoker.$model" :placeholder="data.tglAkhir"></date-picker>
      </b-form-group>

      <b-form-group label-cols-md="3">
        <template v-slot:label>
          {{ $store.state.form.fotoPoster }}
        </template>
        <b-form-file id="file1" ref="file1" type="file" @input="handleFile()"></b-form-file>

        <!-- Improved Image Display -->
        <div v-if="src1 || data.poster" class="mt-3 d-flex justify-content-start">
          <div class="image-preview p-2 shadow-sm rounded bg-white">
            <img :src="src1 ? src1 : data.poster ? img_ip + data.poster : null" alt="Poster Lowongan" class="img-fluid rounded" />
          </div>
        </div>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "modalInput",
  props: ["divisi", "data", "edit"],
  components: {
    quillEditor,
  },
  data() {
    return {
      posisi: [],
      src1: null,
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
    img_ip() {
      return this.$store.state.kode_client ? this.$be + "api-" + this.$store.state.kode_client + "/" : this.$be;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      namaLoker: {
        required,
      },
      masterDivisiId: {
        required,
      },
      posisi: {
        required,
      },
      tanggalAkhirLoker: {
        required,
      },
    },
  },
  watch: {
    isValid(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$emit("dataFromChild", this.data);
      }
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    handleFile() {
      this.data.file1 = this.$refs.file1.files[0];
      this.src1 = URL.createObjectURL(this.data.file1);
      this.upload_poster();
    },
    ngirim() {
      let vm = this;
      this.$emit("dataFromChild", vm.data);
    },
    async getPosisi(x) {
      let vm = this;
      if (x) {
        vm.posisi = [];
        vm.data.masterPosisiId = "";
        let posisi = await vm.$axios.get("masterPosisi/listPosisiByMasterDivisiId/" + x.id);
        // console.log("posisi", posisi);
        vm.posisi = posisi.data.data;
      }
    },
    upload_poster() {
      let vm = this;
      console.log(vm.data.lokerId);
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      let formData = new FormData();
      formData.append("id", vm.data.lokerId);
      formData.append("file1", vm.data.file1);
      vm.$axios
        .post("loker/update", formData)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.busy = false;
            vm.$store.commit("set_alert", {
              variant: "success",
              msg: "BERHASIL MENGUBAH POSTER LOWONGAN KERJA",
              showing: true,
            });
          } else {
            vm.busy = false;
            vm.$store.commit("set_alert", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$store.commit("set_alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>

<style scoped>
.image-preview {
  max-width: 250px; /* biar lebih besar */
  border: 1px solid #e5e7eb; /* abu-abu lembut */
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.2s ease-in-out;
}

.image-preview:hover {
  transform: scale(1.05);
}
</style>
